// extracted by mini-css-extract-plugin
export default {"card":"ChartCard_card__pecXh","header":"ChartCard_header__Gmffa","icon":"ChartCard_icon__X-Yi4","title":"ChartCard_title__lx2+I","content":"ChartCard_content__pIx7d"};